<template>
  <div class="case">
    <div v-if="isScrolled9">
      <Header />
    </div>
    <div style="height: 5em"></div>
    <div class="usercontent">
      <div class="box">
        <!-- Breadcrumbs -->
        <div class="Breadcrumbs">
          <div class="box">
            <a href="/">{{$t('message.home')}} <span>></span></a>
            <a>{{$t('message.userCenter')}}</a> <span>></span> {{ title }}
          </div>
        </div>
        <div class="ucontent">
          <div class="lbox">
            <ul>
              <li :class="{ on: page === 'order' }">
                <a @click="
                  getPage('order');
                selected = 'order';
                ">{{$t('message.myOrder')}}</a>
              </li>
              <li :class="{ on: page === 'plan' }">
                <a @click="
                  getPlan('plan');
                selected = 'plan';
                ">{{$t('message.myPlan')}}</a>
              </li>
              <!-- 暂时注释团队版 -->
              <!-- <li :class="{ on: page === 'team' }">
                <a @click="
                  getTeam('team');
                selected = 'team';
                ">{{$t('message.myTeam')}}</a>
              </li> -->
              <li :class="{ on: page === 'info' }" @click="
                getUserInfo();
              selected = 'info';
              ">
                <a>{{$t('message.myInfo')}}</a>
              </li>
              <li :class="{ on: page === 'message' }">
                <a @click="
                  getMessage('message');
                selected = 'message';
                ">{{$t('message.myMessage')}}</a>
              </li>
              <!-- <li :class="{ on: page === 'exit' }">
                <a @click="
                  exit();
                selected = 'exit';
                ">{{$t('message.exit')}}</a>
              </li> -->
            </ul>
          </div>
          <!-- 我的订单 -->
          <div v-if="page === 'order'" class="rbox">
            <div class="rlist f_taocan">
              <ul>
                <li>
                  <div class="tb1">
                    <div class="ts1">{{$t('message.orderName')}}</div>
                    <div class="ts2">{{$t('message.orderAmount')}}</div>
                    <div class="ts3">{{$t('message.payMethod')}}</div>
                    <div class="ts4">{{$t('message.orderStatus')}}</div>
                    <div class="ts5">{{$t('message.action')}}</div>
                  </div>
                </li>
                <li v-for="(item, index) in orderInfoList" :key="index">
                  <div class="tbox">
                    <div class="tb1">
                      <div class="ts1">{{ item.productName }}</div>
                      <div class="ts2">¥ {{ item.orderTotalAmount }}</div>
                      <div class="ts3">{{ item.payName }}</div>
                      <div v-if="item.orderStatus === 0" class="ts4">
                        {{$t('message.pending')}}
                      </div>
                      <div v-if="item.orderStatus !== 0 && item.orderTotalAmount >= 100
                        " class="ts4">
                        <a @click="goContact" style="color: #75c8ff; margin-left: -20%" class="f_a">{{$t('message.applyInvoice')}}</a>
                      </div>
                      <div v-if="item.orderStatus !== 0 && item.orderTotalAmount <= 100
                        " class="ts4">
                        {{$t('message.paid')}}
                      </div>
                      <div class="ts5">
                        <a @click="payOrder(item)" class="ts12" v-if="item.orderStatus === 0">{{$t('message.goPay')}}</a>
                        <a class="del f_del f_a" data-id="4750" style="margin-left: 5px"
                          @click="deleteOrder(item.orderId)">{{$t('message.delete')}}</a>
                      </div>
                    </div>
                    <div class="tb2">
                      <div class="number">订单编号：{{ item.orderCode }}</div>
                      <div class="time">下单时间：{{ item.addTime }}</div>
                    </div>
                  </div>
                </li>
                <li v-if="orderInfoList && orderInfoList.length === 0" class="zan">
                  <div class="nhave">{{$t('message.noData')}}</div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 我的套餐 -->
          <div v-if="page === 'plan'" class="rbox">
            <div class="rlist f_taocan">
              <ul>
                <li>
                  <div class="tb1">
                    <div class="ts6">{{$t('message.planName')}}</div>
                    <div class="ts6">{{$t('message.planType')}}</div>
                    <div class="ts7">{{$t('message.duration')}}</div>
                    <div class="ts8">{{$t('message.memberTime')}}</div>
                    <div class="ts9">{{$t('message.memberCount')}}</div>
                    <!-- <div class="ts10">操作</div> -->
                  </div>
                </li>

                <li v-for="(item, index) in planInfoList" :key="index">
                  <div class="tbox">
                    <div class="tb1">
                      <div class="ts6">{{ item.productName }}</div>
                      <div class="ts6">
                        {{ item.productType === 1 ? $t('message.personal') : $t('message.team') }}
                      </div>
                      <div class="ts7">{{$t('message.daysLeft', { days: item.diff })}}</div>
                      <div class="ts8" style="line-height: 1">
                        <p>{{ item.confirmTime }}</p>
                        <p>~</p>
                        <p>{{ item.dueTime }}</p>
                      </div>
                      <div class="ts9">{{ item.number || "1" }}</div>
                      <!-- <div class="ts10 f_but1">
                        <a href="/price" class="f_a">续费</a>
                      </div> -->
                    </div>
                  </div>
                </li>
                <li class="zan" v-if="planInfoList && planInfoList.length === 0">
                  <div class="nhave">{{$t('message.noData')}}</div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 暂时注释团队版 -->
          <!-- <div v-if="page === 'team'" class="rbox">
            <div v-if="typeof teamInfo !== 'undefined'" class="team-box">
              <div class="tbox1">
                <div class="t1">{{$t('message.teamInfo')}}<span>{{$t('message.teamId')}}： {{ teamInfo.团队ID }}</span></div>
                <div class="t2">
                  <div class="ts2">
                    <div class="td" style="margin-bottom: 5px;">{{$t('message.teamMemberCount')}}： {{ teamInfo.团队人数 }}{{$t('message.people')}}</div>
                    <div class="td" style="margin-bottom: 5px;">{{$t('message.teamPlanName')}}： {{ teamInfo.套餐名称 }}</div>
                    <br>
                    <div class="td" style="margin-bottom: 5px;">
                      {{$t('message.teamPlanTime')}}： {{ teamInfo.套餐时间 }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="tbox2">
                <div class="t1">{{$t('message.myMembers')}}</div>
                <div class="t2">
                  <div class="ts1">
                    <img src="https://www.yasubit.com/template/pc/skin/images/icon45.png" alt="" />
                    {{ membersInfo[0] }}
                  </div>
                  <div class="ts2">{{$t('message.admin')}}</div>
                </div>
                <div class="t2" v-for="(item, index) in membersInfo.slice(1)" :key="index">
                  <div class="ts1">
                    <img src="https://www.yasubit.com/template/pc/skin/images/icon45.png" alt="" />{{ item }}
                  </div>
                  <div v-if="isCreator" class="ts2">
                    <div class="delete" @click="removeMember(item)">{{$t('message.remove')}}</div>
                  </div>
                </div>
              </div>
              <div v-if="isCreator" class="tbox3">
                <div class="t1">{{$t('message.addMember')}}</div>
                <div class="t2">
                  <input type="text" id="name" :placeholder="$t('message.inputNewMemberId')" class="txt" v-model="newTeamUser" />
                  <input type="button" :value="$t('message.add')" class="btn" style="cursor: pointer" @click="addMember" />
                </div>
                <div class="t3" style="display: none">
                  <div class="ts1">
                    <img src="https://www.yasubit.com/template/pc/skin/images/icon45.png" alt="" /><span></span>
                  </div>
                  <div class="ts2">
                    <div class="delete">添加</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="typeof teamInfo === 'undefined'" class="team-box noteam">
              <div class="tbox">
                <div class="img">
                  <img src="https://www.yasubit.com/template/pc/skin/images/img25.png" alt="" />
                </div>
                <a href="/#/price">{{$t('message.createTeam')}}</a>
                <div class="tips">{{$t('message.noTeamTips')}}</div>
              </div>
            </div>
          </div> -->

          <!-- 个人资料 -->
          <div v-if="page === 'info'" class="rbox">
            <div class="uinformation" v-if="userInfo !== undefined">
              <div class="title">{{$t('message.myInfo')}}</div>

              <div class="tbox">
                <div class="t1">{{$t('message.userName')}}</div>

                <div class="t2 f_int">
                  <span v-if="!inputShow">{{ userInfo.nickname }}</span>
                  <el-input style="width: 50%" size="small" @change="handleName" v-if="inputShow"
                    v-model="input"></el-input>
                  <img @click="changeName" class="ct2" src="https://www.yasubit.com/template/pc/skin/images/icon46.png" />
                </div>
              </div>
              <div class="tbox">
                <div class="t1">{{$t('message.userId')}}</div>
                <div class="t2">{{ userInfo.username }}</div>
              </div>
              <div class="tbox">
                <div class="t1">{{$t('message.password')}}</div>
                <div class="t2 cmm f_a" @click="changePassWord = true">
                  {{$t('message.changePassword')}}
                </div>
              </div>
              <div class="tbox">
                <div class="bd bdyx f_a">{{$t('message.bindEmail')}}</div>
              </div>
              <div class="tbox">
                <div class="bd bdtx f_a">{{$t('message.bindInviter')}}</div>
              </div>
            </div>
          </div>
          <!-- 我的消息 -->
          <div v-if="page === 'message'" class="rbox">
            <div class="unews">
              <ul>
                <li v-for="(item, index) in myMessage" :key="index">
                  <div class="t1">{{ item.operation }}</div>
                  <div class="t2">{{ item.message }}</div>
                  <!-- <a href="javascript:;" class="t3">立即去填写</a> -->
                  <div class="f_text">
                    <a data-id="1315" class="t3 f_del" style="color: red;"></a>
                    <div class="f_te" style="margin-top: 12px;">{{ item.addTime.replace("T", " ") }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改密码弹窗 -->
    <div class="changemm" :style="{ display: changePassWord ? 'block' : 'none' }">
      <div class="box">
        <div><img src="/template/pc/skin/images/icon13.png" alt="" /></div>
        <div class="title">{{$t('message.changePasswordTitle')}}</div>
        <input type="password" class="t1" id="pas3" :placeholder="$t('message.oldPassword')" v-model="formData.oldPassword" />
        <input type="password" class="t1" id="pas1" :placeholder="$t('message.newPassword')" v-model="formData.newPassword" />
        <input type="password" class="t1" id="pas2" :placeholder="$t('message.repeatNewPassword')" v-model="formData.newPasswordConfirm" />
        <p class="f_xi">{{$t('message.passwordRule')}}</p>
        <div class="ck">
          <input type="submit" :value="$t('message.confirm')" @click="submitForm()" class="btn" style="cursor: pointer" />
          <div class="close2" @click="close()">{{$t('message.cancel')}}</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/views/footer.vue";
import Header from "@/views/header.vue";
import Header1 from "@/views/header1.vue";
export default {
  created() {
    this.getData();
    xiayuz
  },
  watch: {
    "$route.query.page"(newValue) {
      this.page = newValue || "order";
    },
  },
  components: {
    Header,
    Header1,
    Footer,
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll9);
    window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
        });
  },
  methods: {
    handleScroll9() {

      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }

    },
    goContact() {
      this.$router.push({ name: "contact" });
    },
    handleName() {
      console.log(111);
      this.updateName();
      this.inputShow = false;
    },
    updateName() {
      const token = localStorage.getItem("loginToken");
      const headers = { Authorization: `Bearer ${token}` };
      const nickName = this.input; // 假设 this.input 包含了新的昵称数据
      // 更新昵称
      this.$http
        .put("yasubit/users/updateNickName", { nickName }, { headers })
        .then((response) => {
          // 处理成功响应
          console.log("Nickname updated successfully:", response.data);
          this.getData();
          // 可以在这里进行其他操作，比如更新本地状态等
        })
        .catch((error) => {
          // 处理请求失败
          console.error("Error updating nickname:", error);
          // 可以在这里进行其他错误处理，比如显示错误消息给用户
        });
    },

    changeName() {
      this.inputShow = true;
      this.input = this.userInfo.nickname;
    },
    payOrder(item) {
      this.$router.push({ path: "pay" });
      sessionStorage.setItem("orderMsg1", item.orderCode);
      sessionStorage.setItem("orderMsg2", item.productName);
      sessionStorage.setItem("orderMsg3", item.orderTotalAmount);
    },
    getData() {
      const token = localStorage.getItem("loginToken");
      const headers = { Authorization: `Bearer ` + token };
      // 获取我的订单
      // this.$http
      //   .get("yasubit/users/orderInfo", { headers })
      //   .then((response) => {
      //     this.orderInfoList = response.data.data;
      //     // 获取已支付的订单，格式化日期
      //     this.formatPlanInfo();
      //   })
      //   .catch((error) => {
      //     // 请求失败时处理错误
      //     console.error("Error fetching data:", error);
      //   });

      // 获取我的消息
      this.$http
        .get("yasubit/team/getMessage", { headers })
        .then((response) => {
          this.myMessage = response.data.data;
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });

      // 获取团队信息
      this.$http
        .get("yasubit/team/my_team", { headers })
        .then((response) => {
          this.teamInfo = response.data.data;
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });

      Promise.all([
        // 获取团队成员信息
        this.$http.get("yasubit/team/team_members", { headers }),
        // 获取个人资料
        this.$http.get("yasubit/users/info", { headers }),
        // 获取订单信息
        this.$http.get("yasubit/users/orderInfo", { headers })
      ]).then(([membersRes, infoRes, orderRes]) => {
        // 成员信息
        this.membersInfo = membersRes.data.data;
        // 个人资料
        this.userInfo = infoRes.data.data;
        console.log("userinfo", this.userInfo);
        if (this.membersInfo !== undefined && this.userInfo.username === this.membersInfo[0]) {
          this.isCreator = true;
        }
        // 我的订单，排除掉已删除的订单和团队订单
        const allOrderList = orderRes.data.data;
        this.orderInfoList = allOrderList.filter(order => order.isGai === 0 && order.usersId === this.userInfo.usersId);
        // 我的套餐
        this.planInfoList = allOrderList.filter((item) => item.orderStatus === 1);
        this.formatPlanInfo();

      }).catch((error) => {
        // 处理错误
        console.error(error);
      });

    },
    // 格式化我的套餐
    formatPlanInfo() {
      this.planInfoList.forEach((item) => {
        const time = item.dueTime.split("T")[0];
        const dueTime = new Date(time);
        const dayDiff = Math.ceil((dueTime - new Date()) / (1000 * 3600 * 24));
        item.confirmTime = item.confirmTime.split(" ")[0];
        item.dueTime = time;
        item.diff = dayDiff > 0 ? dayDiff : 0;
      });
    },
    getPage() {
      this.page = "order";
      this.title = "我的订单";
    },
    getPlan() {
      this.page = "plan";
      this.title = "我的套餐";
    },
    getTeam() {
      this.page = "team";
      this.title = "我的团队";
    },
    // 获取当前用户信息
    getUserInfo() {
      this.page = "info";
      this.title = "个人资料";
    },
    getMessage() {
      this.page = "message";
      this.title = "我的消息";
    },
    exit() {
      // 登出，loginStatus设为false，清空loginToken
      localStorage.setItem("loginStatus", JSON.stringify(false));
      localStorage.removeItem("loginToken");
      window.location.href = "/";
    },
    handleScroll1() {
      const scrollDistance =
        window.scrollY || document.documentElement.scrollTop;
      this.isScrolled = scrollDistance >= 950;
    },
    handleScroll() {
      this.isTop = window.scrollY === 0;
    },
    deleteOrder(orderId) {
      const token = localStorage.getItem("loginToken");
      const headers = { Authorization: `Bearer ` + token };
      this.$http
        .delete("yasubit/shop_order/removeById/" + orderId, { headers })
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(this.$t('message.deleteSuccess'));
          }
          this.getData();
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });
    },
    submitForm() {
      if (this.formData.newPassword !== this.formData.newPasswordConfirm) {
        this.$message.error(this.$t('message.passwordNotMatch'));
        return;
      }
      const token = localStorage.getItem("loginToken");
      const headers = { Authorization: `Bearer ` + token };
      this.$http
        .put("yasubit/users/updatePwd", this.formData, { headers })
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(this.$t('message.changeSuccess'));
            this.exit();
            window.location.href = "/";
          } else {
            this.$message.error(response.data.msg);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    close() {
      this.changePassWord = false;
      this.formData = {
        oldPassword: undefined,
        newPassword: undefined,
        newPasswordConfirm: undefined,
      };
    },
    removeMember(item) {
      const token = localStorage.getItem("loginToken");
      const headers = { Authorization: `Bearer ${token}` };
      const username = item;
      this.$http
        .get("yasubit/team/remove_member/" + username, { headers })
        .then((response) => {
          this.$message.success(response.data.msg);
          this.getData();
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });
    },
    addMember() {
      const token = localStorage.getItem("loginToken");
      const headers = { Authorization: `Bearer ${token}` };
      const user = {
        "email": this.newTeamUser
      }
      this.$http.post('yasubit/team/addMember', user, { headers })
        .then(response => {
          if (response.data.code === 200) {
            this.$message.success(response.data.msg);
          } else {
            this.$message.error(response.data.msg);
          }
          this.newTeamUser = undefined;
          this.getData();
        })
        .catch(error => {
          // 请求失败时处理错误
          console.error('Error fetching data:', error);
        });
    },
  },
  data() {
    return {
      //控制管理员展示
      isCreator: false,
      // 控制有团队套餐的展示
      haveTeam: true,
      changePassWord: false,
      inputShow: false,
      input: "",
      userInfo: undefined,
      page: this.$route.query.page || "order",
      isScrolled9: true,
      isScrolled: false,
      title: undefined,
      orderInfoList: [],
      planInfoList: [],
      teamInfo: undefined,
      membersInfo: [],
      newTeamUser: undefined,
      myMessage: [],
      formData: {
        oldPassword: undefined,
        newPassword: undefined,
        newPasswordConfirm: undefined,
      },
    };
  },
};
</script>

<style lang="scss" scoped>


.between{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  //background-color: pink;
}


.one-third-1{
  width: 33.333333%;
  height: 15em;
  //background-color: pink;
}

.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;

}



.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>